import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import moment from "moment";
import editIcons from "../../../../../assets/icons/editIcons.svg";
import addCirculIcon from "../../../../../assets/icons/addCirculIcon.svg";
import { getProgressColor } from "../../../company-dashboard-utils";
import CompanyDashboardInitiativeDrawerSideBarDetailsPopup from "./company-dashboard-initiative-drawer-side-bar-name-popup";
import "./company-dashboard-initiative-drawer-side-bar.scss";

const CompanyDashboardInitiativeDrawerSideBarName: any = (props: any) => {
  const {
    detailsData,
    setDetailsData,
    handleCreateInitiative,
    initiativeId,
    payloadData,
    canEdit,
    statusListInitiatives,
    initiativeDataPermissions,
  } = props;
  const [isShowEditDetails, setIsShowEditDetails] = useState(false);

  return (
    <>
      <div className="company-dashboard-initiative-drawer-side-bar-content-header">
        <div>Name</div>
        {
          <button
            className={
              initiativeId
                ? "company-dashboard-initiative-drawer-side-bar-content-header-edit-icon"
                : "company-dashboard-initiative-drawer-side-bar-content-header-add-icon"
            }
            onClick={() => setIsShowEditDetails(true)}
            style={{
              cursor: "pointer",
              border: "none",
              background: "none",
              padding: 0,
            }}
          >
            {initiativeId && canEdit && initiativeDataPermissions ? (
              <img src={editIcons} alt="edit" />
            ) : null}
          </button>
        }
      </div>
      {detailsData ? (
        <div
          className="company-dashboard-initiative-drawer-side-bar-content-details"
          style={{
            borderBottom: `3px solid ${getProgressColor(detailsData?.status).mainColor}`,
          }}
        >
          <div
            className="company-dashboard-initiative-drawer-side-bar-content-details-content"
            style={{ borderBottom: "1px solid #ccc", marginBottom: "6px" }}
          >
            <div>
              <div className="company-dashboard-initiative-drawer-side-bar-content-details-content-main-label">
                {detailsData?.name}
              </div>
              <div className="company-dashboard-initiative-drawer-side-bar-content-details-content-sub-label">
                Last Updated:{" "}
                <span>
                  {moment(detailsData?.lastUpdated || new Date()).format(
                    "MM-DD-YYYY",
                  ) || ""}
                </span>
              </div>
            </div>
            <div className="company-dashboard-initiative-drawer-side-bar-content-details-content-graph">
              <Box sx={{ position: "relative", display: "inline-flex" }}>
                <CircularProgress
                  variant="determinate"
                  value={100}
                  size={72}
                  thickness={6.2}
                  sx={{
                    color: getProgressColor(detailsData?.status).lightColor,
                  }}
                />
                <CircularProgress
                  variant="determinate"
                  value={detailsData?.progress || 0}
                  size={72}
                  sx={{
                    color: getProgressColor(detailsData?.status).mainColor,
                    position: "absolute",
                    left: 0,
                    "& .MuiCircularProgress-circle": {
                      strokeLinecap: "round",
                    },
                  }}
                  thickness={6.2}
                />
                <Box
                  sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="caption"
                    component="div"
                    sx={{ color: "#403C6F" }}
                  >{`${Math.round(detailsData?.progress || 0)}%`}</Typography>
                </Box>
              </Box>
            </div>
          </div>
          <div
            className="company-dashboard-initiative-drawer-side-bar-content-details-content"
            style={{
              borderBottom: "1px solid #ccc",
              paddingBottom: "6px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className="company-dashboard-initiative-drawer-side-bar-content-details-content-sub-label">
                Reported Status %
              </div>
              <div className="company-dashboard-initiative-drawer-side-bar-content-details-content-sub-label">
                Milestone Completed %
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                marginTop: "8px",
              }}
            >
              <div style={{ fontSize: "14px", color: "#403C6F" }}>
                {Math.round(detailsData?.actualReportedPercentage || 0)}%
              </div>
              <div style={{ fontSize: "14px", color: "#403C6F" }}>
                {Math.round(detailsData?.mileStonePercentage || 0)}%
              </div>
            </div>
          </div>
          <div className="company-dashboard-initiative-drawer-side-bar-content-details-content">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className="company-dashboard-initiative-drawer-side-bar-content-details-content-sub-label">
                Average Progress %
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                marginTop: "8px",
              }}
            >
              <div style={{ fontSize: "14px", color: "#403C6F" }}>
                {Math.round(detailsData?.progress || 0)}%
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="company-dashboard-initiative-drawer-side-bar-content-details-no">
          <button
            onClick={() => setIsShowEditDetails(true)}
            style={{
              cursor: "pointer",
              border: "none",
              background: "none",
              padding: 0,
            }}
          >
            <img
              src={addCirculIcon}
              alt="Owner"
              style={{ cursor: "pointer" }}
            />
          </button>
        </div>
      )}
      <CompanyDashboardInitiativeDrawerSideBarDetailsPopup
        isShowEditDetails={isShowEditDetails}
        setIsShowEditDetails={setIsShowEditDetails}
        detailsData={detailsData}
        setDetailsData={setDetailsData}
        handleCreateInitiative={handleCreateInitiative}
        initiativeId={initiativeId}
        payloadData={payloadData}
        statusListInitiatives={statusListInitiatives}
      />
    </>
  );
};

export default CompanyDashboardInitiativeDrawerSideBarName;
